<template>
  <v-row>
   <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
    <v-snackbar
          v-model="snackbar"
          bottom
          :timeout="timeout"
          :color="color"
          >
          {{ text }}
    </v-snackbar>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>
      <v-card>
        <v-card-title>
          <span class="pb-3 mt-3">
            {{ (selectPa && selectPa.partnerName ? selectPa.partnerName  : '')  }},  {{ lang.FromDate }} {{localDate(startDate)}}, {{ lang.ToDate }} {{localDate(endDate)}},<br />
          </span>
          <span class="pb-3 mt-3">
             {{ lang.Invoices }} {{localMoney(fullPls)}} - {{ lang.Approvals }} {{localMoney(fullMns)}} = {{ lang.InvState }} {{localMoney(fullPls-fullMns)  }} <br />
          </span>
          <v-dialog
            v-model="showPeriod"
            max-width="350px"
          >
            <v-card>
              <v-card-text>
                 <v-row dense>
                  <v-col cols="12" >
                    <span class="headline">{{ (selectPa && selectPa.partnerName ? selectPa.partnerName  : '') }}  </span>
                  </v-col>
                </v-row>

                 <v-divider class="mt-1"></v-divider>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    {{langC.FromDate}}: <input type="date" ref="docdate"  v-model="startDate" />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    {{langC.ToDate}}: <input type="date" v-model="endDate" />
                  </v-col>
                </v-row>

                 <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-select
                      v-model="selectedMonth"
                      :items="months"
                      label="Mjesec"
                      clearable
                    ></v-select>
                  </v-col>
                </v-row>
                <!-- <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="groupInOut(1)">
                      Kartica cijela
                    </v-btn>
                  </v-col>
                </v-row> -->
                <!-- <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="groupInOut(2)">
                      Kartica otvoreni predujmi
                    </v-btn>
                  </v-col>
                </v-row> -->
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" > 
                    <v-btn
                      color="gray" block
                      @click="printAna()">
                      {{langC.Print}}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" > 
                    <v-btn
                      color="gray" block
                      @click="downloadFile()">
                      Excel
                    </v-btn>
                  </v-col>
                </v-row>


                 <v-divider class="mt-3 mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" >
                    <v-btn color="green" block @click="refreshPeriod()">Refresh</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" >
                    <v-btn color="primary" block @click="switchPeriod()">Zatvori</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                
              </v-card-actions>
            </v-card>
          </v-dialog>
 
          
          <v-row no-gutters v-if="!showPeriod">

            <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

            </v-col>
              
              <v-col cols="12" sm="2" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
                <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
              <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2"  >
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  v-model="search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
            <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >
              <v-btn
                color="primary"
                @click="switchPeriod()">
                Opcije
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>


        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="navigateTo"
          >
          <template v-slot:[`item.documentDate`]="{ item }">
              <span>{{ localDate(item.documentDate) }}</span>
          </template>
           <template v-slot:[`item.documentInvoiceEndDate`]="{ item }">
              <span>{{ localDate(item.documentInvoiceEndDate) }}</span>
          </template>

          <template v-slot:[`item.eRacunPoslovniProcesSifra`]="{ item }">
              <span v-if="(item.eRacunPoslovniProcesSifra !=='P9' && item.eRacunPoslovniProcesSifra !=='P10')">{{ item.eRacunPoslovniProcesSifra}}</span>
              <span v-if="(item.eRacunPoslovniProcesSifra ==='P9' || item.eRacunPoslovniProcesSifra ==='P10')" style="color:red">{{ item.eRacunPoslovniProcesSifra}}</span>
          </template>
          <template v-slot:[`item.docStatus`]="{ item }">
            <span v-if="item.docStatus">
              <v-chip small :color="item.docColor" dark>{{ item.docStatus }}</v-chip>
            </span>
          </template>
           <template v-slot:[`item.RefNaPrethodniRacunDatum`]="{ item }">
              <span>{{ item.RefNaPrethodniRacunDatum ? localDate(item.RefNaPrethodniRacunDatum) : ''}}</span>
          </template>
          <template v-slot:[`item.ItemBaseAmountNoVAT`]="{ item }">
              <span>{{ localMoney(item.ItemBaseAmountNoVAT) }}</span>
          </template>
          <template v-slot:[`item.ItemVAT1Percentage`]="{ item }">
            <span>{{ localMoney(item.ItemVAT1Percentage) }}</span>
          </template>
          <template v-slot:[`item.ItemAmountWithVAT`]="{ item }">
              <span>{{ localMoney(item.ItemAmountWithVAT) }}</span>
          </template>
          <template v-slot:[`item.ItemAmountWithVATminus`]="{ item }">
              <span>{{ localMoney(item.ItemAmountWithVATminus) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
          <template v-slot:no-data>
            {{ lang.noDataList }}
          </template>
        </v-data-table>

      </v-card>
      <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <DocumentCardSalesPrint ref="prnt"/>
      </v-col>
    </v-row>
  </v-col>
 </v-row>
</template>

<script>
// import axios from 'axios'
import DocumentService from '@/services/DocumentService'
import PartnerService from '@/services/PartnerService'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import DocumentCardSalesPrint from './DocumentCardSalesPrint'
import { parseNum, round } from '@/snippets/allSnippets'
import xlsx from 'json-as-xlsx'
import dayjs from 'dayjs'
import { F } from 'pdfmake/build/pdfmake'

export default {
  name: 'documentcardsales',
  props: [],
  data () {    
    return {
      items: [],
      itemsLoc: [],
      itemsWH: [],
      documentName: '',
      documentNameLoc: '',
      msg: '',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {},
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      documentAna: {},
      selectPa: {},
      savedDocument: {},
      ana: {},
      privGroups: [],
      selectGroup: {},
      haveGroupId: null,
      showCard: false,
      refreshCard: 0,
      disableGroup: false,
      onTime: '',
      showPeriod: false,
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      selectedMonth: null,
      startDate: null,
      endDate: null,
      dialog1: false,
      dialog2: false,
      modal1: false,
      modal2: false,
      all: {},
      grTotalIn: 0,
      grTotalOut: 0,
      grTotalSum: 0,
      groups: [],
      groupin: [],
      groupout: [],
      docDetailItems: [],
      snackbar: false,
      text: '',
      color: '',
      timeout: 2000,
      newCardItems: null,
      itemCard: null,
      totalPcs: 0,
      totalSupp:0,
      totalMargin:0,
      totalNetto:0,
      totalVAT:0,
      totalTotal:0,
      fullPls: 0,
      fullMns: 0
    }
  },
  async mounted () {

    // do analysis from database
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    // console.log('u kartici this.$store.state.partnerStore.', this.$store.state.partnerStore.find(part => (part.id === this.$store.state.partnerid)))
    // this.selectPa = this.$store.state.partnerStore.find(partner => (partner.id === this.$store.state.partnerid))
    
    // console.log('this.selectPa', this.selectPa)
    await this.findPartner(this.$store.state.partnerid)

    this.onTime = dayjs([this.$store.state.businessYear]).startOf('year').format('DD.MM.YYYY') + '-' + dayjs(new Date()).format('DD.MM.YYYY') + ', ' + dayjs(new Date()).format('HH:mm:ss')

    this.headers.push(
      {text: this.lang.documentId, value: 'documentId', width: '80px'},
      {text: this.lang.DocumentDate, value: 'documentDate', width: '85px'},
      {text: this.lang.documentInvoiceEndDate, value: 'documentInvoiceEndDate', width: '85px'},
      {text: this.lang.TipDokumentaBroj, value: 'TipDokumentaBroj', width: '50px'},
      {text: this.lang.eRacunPoslovniProces, value: 'eRacunPoslovniProcesSifra', width: '50px'},
      {text: this.lang.docStatus, value: 'docStatus', width: '85px'},
      {text: this.lang.RefNaPrethodniRacun, value: 'RefNaPrethodniRacun', width: '85px'},
      {text: this.lang.RefNaPrethodniRacunDatum, value: 'RefNaPrethodniRacunDatum', width: '90px'},
      {text: this.lang.ItemBaseAmountNoVAT, value: 'documentTotalAmountNetto', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.ItemVAT1Percentage, value: 'documentTotalAmountVAT', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.ItemAmountWithVAT, value: 'documentTotalAmountBrutto', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.ItemAmountWithVATminus, value: 'documentTotalAmountBruttominus', align: 'right', width: '100px'},
      {text: this.lang.id, value: 'id', width: '50px'}
    )

    if (this.$store.state.companyid) {
      this.documentAna.CompanyId = this.$store.state.companyid
    }
    if (this.$store.state.businessYear) {
      this.documentAna.BusinessYear = this.$store.state.businessYear
    }
    const fDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
    const tDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')

    this.startDate = this.fromDate ? this.fromDate : fDate
    this.endDate = this.toDate ? this.toDate : tDate

    console.log('startDate', this.startDate)

    this.documentAna.docFromDate = this.fromDate ? this.fromDate : fDate
    this.documentAna.docToDate = this.toDate ? this.toDate : tDate

    await this.initData(1)
  },
  methods: {
    switchPeriod() {
      this.showPeriod = !this.showPeriod
    },
    async findPartner(id) {
      try {
        this.selectPa =  (await PartnerService.findbyid(id)).data.partner
      } catch (error) {
        alert('Error! Can not find partner. Ne mogu naci partnera!')
      }
    },
    async refreshPeriod(){
      this.switchPeriod()
      if (this.startDate) {
        this.documentAna.docFromDate = this.startDate
      }
      if (this.endDate) {
        this.documentAna.docToDate = this.endDate
      }
      await this.initData(1)
      this.switchPeriod()
    },
    navigateTo(item) {
      this.$store.dispatch('setDocumentFrom', item)
    },
    async initData(type) {
      try {
        if (!this.$store.state.partnerid) {
          alert('Nije odabran niti jedan partner za karticu!. Partner is NOT selected!')
          return
        }
        this.localError = false
        this.error = null
        this.items.length = 0
        
        this.haveGroupId = null
        this.documentAna.partnerId = this.$store.state.partnerid
        this.documentAna.documentName='InvoiceSales'

        this.onTime = this.localDate(this.documentAna.docFromDate) + '-' + this.localDate(this.documentAna.docToDate)

        //console.log('this.documentAna', this.documentAna)

        this.saving = true
        const res = (await DocumentService.documentsalesana(this.documentAna)).data
        const tempItems = res.document? res.document : []
        this.fullPls = 0
        this.fullMns = 0

        if (tempItems && tempItems.length>0 ) {
          tempItems.map(itm => {
            const newItm = {...itm}
            let doPlus = true
            newItm.ItemAmountWithVATminus = null
            if (itm.eRacunPoslovniProcesSifra === 'P8' || itm.eRacunPoslovniProcesSifra === 'P9' || itm.eRacunPoslovniProcesSifra === 'P10'){
              newItm.documentTotalAmountBrutto = 0
              newItm.documentTotalAmountBruttominus = itm.documentTotalAmountBrutto
              this.fullMns += parseNum(itm.documentTotalAmountBrutto)
              doPlus = false
            }
            if (doPlus) {
              this.fullPls += parseNum(itm.documentTotalAmountBrutto)
            }
            this.items.push(newItm)
          })
        }

        this.typeAna = 4
        //this.items= [...tempItems]
        this.saving = false
      } catch(err) {
        this.error = 'Greska u konekciji na bazu' + err
      }
    },
    selectItems() {
      this.initData(2)
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },

    async printAna() {
      const newObj = {}
      this.ana = {...newObj}
      this.ana = {...this.documentAna}
      this.ana.partnerName = this.selectPa.partnerName
      this.ana.fullPls = this.fullPls
      this.ana.fullMns = this.fullMns 

      this.ana.docFromDate =  this.localDate(this.documentAna.docFromDate)
      this.ana.docToDate =  this.localDate(this.documentAna.docToDate)

      this.ana.items = this.items ? this.items : []
      await this.$store.dispatch('setPrintObj', this.ana)
      await this.$refs.prnt.print()
    },
    downloadFile () {
        const currDate = dayjs().format('DD_MM_YYYY_HH_MM')  
        const sheetNm = 'Fakture' + '_' + currDate
        let data = [
        {
          sheet: sheetNm,
          columns: [
            {label: this.lang.documentId, value: 'documentId'},
            {label: this.lang.DocumentDate, value: 'documentDate'},
            {label: this.lang.documentInvoiceEndDate, value: 'documentInvoiceEndDate'},
            {label: this.lang.TipDokumentaBroj, value: 'TipDokumentaBroj'},
            {label: this.lang.eRacunPoslovniProces, value: 'eRacunPoslovniProcesSifra'},
            {label: this.lang.docStatus, value: 'docStatus'},
            {label: this.lang.RefNaPrethodniRacun, value: 'RefNaPrethodniRacun'},
            {label: this.lang.RefNaPrethodniRacunDatum, value: 'RefNaPrethodniRacunDatum'},
            {label: this.lang.ItemBaseAmountNoVAT, value: 'documentTotalAmountNetto'},
            {label: this.lang.ItemVAT1Percentage, value: 'documentTotalAmountVAT'},
            {label: this.lang.ItemAmountWithVAT, value: 'documentTotalAmountBrutto'},
            {label:this.lang.ItemAmountWithVAT, value: 'documentTotalAmountBruttominus'},
            {label: this.lang.id, value: 'id'}
          ],
          content: this.items
        }
      ]
          
      let settings = {
          fileName: 'Fakture_' + currDate,
          extraLength: 3, // A bigger number means that columns will be wider
          writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
        }
      // const settings = {
      //   sheetName: 'StanjeSkladista',
      //   fileName: 'StanjeSkladista_' + currDate
      // }
      xlsx(data, settings)
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },

  },
  computed: {
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  watch: {

    'selectedMonth' () {
     if  (this.selectedMonth) {
        let date = new Date(), y = date.getFullYear(), m = this.selectedMonth - 1;
        let firstDay = new Date(y, m, 1);
        let lastDay = new Date(y, m + 1, 0);

        this.startDate = dayjs(firstDay).format('YYYY-MM-DD')
        this.endDate = dayjs(lastDay).format('YYYY-MM-DD')
      }
      if (!this.selectedMonth) {
        this.startDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
        this.endDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
      }
    },
  },
  components: {
    DocumentCardSalesPrint
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


